import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { SmsEvent, SmsEventsFilters } from '@models/smsEvent'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import smsEventsApi from './actions'
import { smsEventsKeys } from './constants'

interface UseSmsEventsData {
  smsEvents: SmsEvent[]
  smsEventsMap: Map<number, SmsEvent>
  pagination: PaginationMeta
}

export const selectData = ({
  data,
  pagination,
}: PaginatedResponse<SmsEvent>): UseSmsEventsData => ({
  smsEvents: data,
  smsEventsMap: new Map(data.map(smsEvent => [smsEvent.id, smsEvent])),
  pagination,
})

const useSmsEventsAdmin = (filters: SmsEventsFilters) =>
  useQuery<PaginatedResponse<SmsEvent>, AxiosError, UseSmsEventsData>(
    smsEventsKeys.smsEventsAdmin(filters),
    () => smsEventsApi.getSmsEventsAdmin(filters),
    { enabled: !!filters.companyId, select: selectData },
  )

export default useSmsEventsAdmin
